module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-stone-path-background-remnants.9f648216.png";